import {
  animate,
  animation,
  query,
  sequence,
  stagger,
  style,
  transition,
  trigger,
  useAnimation
} from '@angular/animations';

export const menuActiveAnimationStagger = animation([
  query('.l-menu-item-container', [
    style({ transform: 'translateX(-{{ menuW }})', opacity: 0})
  ]),
  query('.l-menu-category', [
    style({ transform: 'translateX(-{{ menuW }})', opacity: 0})
  ]),
  query('.l-user', [
    style({ transform: 'translateX(-{{ menuW }})', opacity: 0})
  ]),
  sequence([
    query('.l-menu-category', [
      stagger(50, [ animate('150ms ease-in-out'), style({ transform: 'none', opacity: 1}) ])
    ]),
    query('.l-menu-item-container', [
      stagger(50, [ animate('150ms ease-in-out'), style({ transform: 'none', opacity: 1}) ])
    ]),
    query('.l-user', [
      stagger(1, [ animate('100ms ease-in-out'), style({ transform: 'none', opacity: 1}) ])
    ]),
  ])
]);

export const menuActiveAnimation = trigger('menuActiveAnimation', [
  transition(':enter', [
    useAnimation(menuActiveAnimationStagger, {
      params: {
        menuW: '300px'
      }
    })
  ])
]);

